/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { ClickAwayListener, MenuList, MenuItem } from '@mui/material';

import { STODocument } from 'commons/types';

import { RowMenuItemBulkConfig } from '../configs';

const BulkActionBtnSTOMenu: React.FC<{
  selectedDocuments: STODocument[];
  handleCloseMenu: () => void;
  handleOpen: (name: string) => void;
}> = (params) => {
  const { selectedDocuments, handleCloseMenu, handleOpen } = params;

  return (
    <ClickAwayListener onClickAway={handleCloseMenu}>
      <MenuList id="split-button-menu" autoFocusItem>
        {RowMenuItemBulkConfig.map((config) => (
          <MenuItem
            onClick={() => handleOpen(config.title)}
            disabled={config.disabled(selectedDocuments)}
            key={`menu-item-${config.title}`}
          >
            {config.title}
          </MenuItem>
        ))}
      </MenuList>
    </ClickAwayListener>
  );
};

export default BulkActionBtnSTOMenu;
